import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CrossIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CrossIconPath";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./FailureRating.module.css";
import { Trans } from "@coworker/locales";

interface FailureRatingProps {
  maxCriteria: number;
  failedCriteria: number;
  message: string;
}

export const FailureRating = ({
  maxCriteria,
  failedCriteria,
  message,
}: FailureRatingProps) => {
  const passedCriteria = maxCriteria - failedCriteria;

  return (
    <>
      <div className={styles["container"]}>
        {/* Failed criteria - red */}
        {Array.from({ length: failedCriteria }, (_, index) => (
          <div
            key={`failed-${index}`}
            className={`${styles["iconWrapper"]} ${styles["failed"]}`}
          >
            <FixaSSRIcon paths={CrossIconPath} />
          </div>
        ))}
        {/* Passed criteria - grey */}
        {Array.from({ length: passedCriteria }, (_, index) => (
          <div key={`passed-${index}`} className={styles["iconWrapper"]}>
            <FixaSSRIcon paths={CrossIconPath} />
          </div>
        ))}
      </div>
      <FixaText textStyle="Body.S">
        <Trans i18nKey={message} values={{ failedCriteria, maxCriteria }} />
      </FixaText>
    </>
  );
};
